
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 2.5l-5.5 9h11l-5.5-9zm0 3.84l1.93 3.16h-3.87L12 6.34zm5.5 7.16c-2.49 0-4.5 2.01-4.5 4.5s2.01 4.5 4.5 4.5S22 20.49 22 18s-2.01-4.5-4.5-4.5zm0 7a2.5 2.5 0 110-5 2.5 2.5 0 010 5zM3 22h8v-8H3v8zm2-6h4v4H5v-4z","fill":"#627798"}})])
          )
        }
      }
    